import { client } from '@/sanity/lib/client';
import ThemeArchive from '@/src/components/screens/ThemeArchive/ThemeArchive';

import themeArchiveQuery from '@/src/assets/queries/themeArchiveQuery';

import { ITheme } from '../../assets/interfaces/themeInterface/index';

type THomePageProps = {
    data: ITheme[];
};

export default function HomePage({ data }: THomePageProps) {
    return <ThemeArchive themesData={data} />;
}

export async function getStaticProps() {
    const data = await client.fetch(themeArchiveQuery);

    return {
        props: {
            data: data ?? null,
        },
        revalidate: 10,
    };
}
